<template>
  <div
    id="rh-header-slot"
    class="mh-100 d-flex flex-column flex-nowrap justify-content-between align-items-start"
    :style="outerStyle"
  >
    <div class="mh-100 w-100 d-flex flex-nowrap justify-content-between align-items-start">
      <div
        class="pl-3 pt-3"
        :style="innerStyle"
      >
        <TTReader
          :panel="panel"
          data-cy="header-panel"
        />
      </div>
      <NavButtons
        v-if="showNavButtons"
        id="nav-buttons"
        data-test="nav-buttons"
        class="d-flex flex-nowrap p-2"
      />
    </div>
    <ClickableBreadcrumbs class="desktop" />
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import TTReader from '@/components/TipTap/wrappers/TTReader.vue'
import NavButtons from '@/components/public/NavButtons/NavButtons.vue'
import ClickableBreadcrumbs from '@/components/public/ClickableBreadcrumbs.vue'
import { StoryKeys } from '@/types'
import { StyleValue } from 'vue/types/jsx'

const components = {
  TTReader,
  NavButtons,
  ClickableBreadcrumbs,
}

const props = {
  panel: {
    type: String,
    default: StoryKeys.ABOVE_BUBBLES,
  },
}

@Component({ components })
export default class HeaderPanel extends Vue.extend({ props }) {
  get showNavButtons () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.isVisualisationApp &&
    !this.$typedStore.activeVisualisation.isCustom
  }

  // MS IE Hack to fix bubble width issue
  get sidebarContainerWidth () {
    return this.$typedStore.public.size.sidebarContainerWidth
  }

  // MS IE Hack to fix bubble width issue
  get sidetabsContainerWidth () {
    return this.$typedStore.public.size.sidetabsContainerWidth
  }

  // MS IE Hack to fix bubble width issue
  get mainContentWidth () {
    return this.$typedStore.public.size.mainContentWidth
  }

  // MS IE Hack to fix bubble width issue
  get navButtonsWidth () {
    return this.$typedStore.public.size.navButtonsWidth
  }

  // MS IE Hack to fix bubble width issue
  get msieversion () {
    return this.$typedStore.public.size.msieversion
  }

  get activeVisualisationIsCustom () {
    return this.$typedStore.activeVisualisation.isCustom
  }

  get width () {
    const width = this.mainContentWidth - this.sidebarContainerWidth - this.sidetabsContainerWidth - this.navButtonsWidth
    return width > 0 ? width : 400
  }

  get outerStyle () : StyleValue {
    if (this.activeVisualisationIsCustom) {
      return {
        position: 'absolute',
        width: '100%',
        'z-index': 1,
      }
    } else {
      return {
        position: 'relative',
      }
    }
  }

  get innerStyle () {
    return this.msieversion ? { 'max-width': this.width + 'px' } : {}
  }
}

</script>
